<template>
	<Col class="width-100 height-100 flex-centerize">
		<Loader v-if="!loaded" text="We are running your feature" />
		<iframe v-show="loaded" @load="loaded = true" class="width-100 height-100" :src="flowRunSrc" />
	</Col>
</template>

<script>
export default {
	name: 'ActionableNotificationRun',
	props: { alert: { type: Object } },
	computed: {
		redirectUrl() {
			return this.alert.metadata.redirect_url;
		},
	},
	data() {
		return { loaded: false, flowRunSrc: null };
	},
	created() {
		const url = new URL(this.redirectUrl);
		url.searchParams.append('inAppMode', true);
		this.flowRunSrc = url;
	},
};
</script>
<style scoped>
iframe {
	border: none;
}
</style>
